module.exports = __webpack_public_path__ + "img/f1.16a2bd95.jpg";